/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandCheckoutSecurityRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandCheckoutSecurityResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandCheckoutSecurity = (request: SetBrandCheckoutSecurityRequest, options?: CashRequestOptions) => post<SetBrandCheckoutSecurityRequest, SetBrandCheckoutSecurityResponse>("/2.0/cash/set-brand-checkout-security", request, {...options, rejectOnError: true })